var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6 19.0249C14.4 19.0249 14.2 18.9249 14.1 18.8249L7.7 12.7249C7.5 12.5249 7.5 12.3249 7.5 12.1249C7.5 11.9249 7.6 11.7249 7.7 11.6249L14.1 5.6249C14.4 5.3249 14.9 5.3249 15.2 5.6249C15.5 5.9249 15.5 6.4249 15.2 6.7249L9.3 12.1249L15.1 17.7249C15.4 18.0249 15.4 18.5249 15.1 18.8249C15 18.9249 14.8 19.0249 14.6 19.0249Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeft);
export default ForwardRef;